// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_ListaCompromissosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /compromissos/lista_compromissos
 *
 * No body required by the controller — the user sub is sourced from the JWT
 * and the list query is driven by the global filter. Empty Input exists so
 * callers can register the inputContract option string for typing and
 * runtime registration.
 */
import { registerContract } from './validate'

export interface Compromissos_ListaCompromissosInput {}

registerContract('Compromissos_ListaCompromissosInput', {})
